import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TCreateInvoiceTemplateRequest,
  TCreateInvoiceTemplateResponse,
} from "./createInvoiceTemplate.schema";

/**
 * @description
 * Creates a new Invoice Template for a company.
 * Posts to la-forge route: POST /api/invoices/templates
 *
 * @param axios - injected axios instance from AbstractApiClient
 * @param params - typed invoice template payload
 * @returns created invoice template data
 */
export const createInvoiceTemplate =
  (axios: IAxiosInstance) =>
  async (
    params: TCreateInvoiceTemplateRequest
  ): Promise<TCreateInvoiceTemplateResponse> => {
    const response = await axios.noRetry.post(
      "/api/invoices/templates",
      params
    );
    const resData = response.data;

    if (resData?.success) {
      return resData.data;
    }

    throw new Error(resData?.error || "Error creating invoice template");
  };
